import * as z from "zod";

export const deleteMasonhubIntegration = {
  name: "deleteMasonhubIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
